import type { ProductsTranslations } from '../interfaces/products';

export const productsTranslations: ProductsTranslations = {
  page_title: 'Catalog',
  page_description:
    'These are the products Luna and your other agents can recommend and sell.',
  stat_active: 'Active products',
  stat_draft: 'Drafts',
  stat_low_stock: 'Low stock',
  stat_out_of_stock: 'Out of stock',
  filter_all: 'All',
  filter_active: 'Active',
  filter_draft: 'Drafts',
  filter_archived: 'Archived',
  filter_category_all: 'All categories',
  sort_recent: 'Recent',
  sort_best_sellers: 'Best sellers',
  sort_low_stock: 'Low stock',
  sort_price_high: 'Highest price',
  sort_price_low: 'Lowest price',
  sort_name_az: 'Name A–Z',
  search_placeholder: 'Search by name, SKU or tag…',
  view_list: 'List view',
  view_grid: 'Grid view',
  action_new_product: 'New product',
  action_export_csv: 'Export CSV',
  action_import: 'Import',
  action_edit: 'Edit',
  action_duplicate: 'Duplicate',
  action_delete: 'Delete',
  action_change_status: 'Change status',
  action_assign_category: 'Assign category',
  action_channel_availability: 'Channel availability',
  bulk_selected: '{{count}} selected',
  bulk_clear: 'Clear selection',
  table_product: 'Product',
  table_category: 'Category',
  table_status: 'Status',
  table_price: 'Price',
  table_stock: 'Stock',
  table_channels: 'Channels',
  table_actions: 'Actions',
  stock_in_stock: 'In stock',
  stock_low: 'Low',
  stock_out: 'Out of stock',
  status_active: 'Active',
  status_draft: 'Draft',
  status_archived: 'Archived',
  form_title_new: 'New product',
  form_title_edit: 'Edit product',
  form_subtitle:
    'What you upload here goes to the catalog Luna and your other agents use to respond, recommend and close sales.',
  section_basic_info: 'Basic information',
  section_basic_info_subtitle: 'The first thing your agents and customers see.',
  section_images: 'Images and media',
  section_images_subtitle:
    'Upload up to 15 images. The first will be the cover.',
  section_pricing: 'Pricing',
  section_pricing_subtitle: 'We calculate the margin automatically.',
  section_inventory: 'Inventory and shipping',
  section_variants: 'Variants',
  section_variants_subtitle:
    'Create options (size, color, scent…) and all combinations will be generated.',
  section_seo: 'SEO and agent context',
  section_seo_subtitle:
    'What Google will see and what your agents will know that is not shown to the customer.',
  field_name: 'Product name',
  field_name_placeholder: 'E.g. Autumn edition aromatic candle',
  field_description: 'Description',
  field_description_placeholder:
    'What your agent will read to answer questions',
  field_category: 'Category',
  field_brand: 'Brand',
  field_tags: 'Tags',
  field_tags_placeholder: 'Type and press Enter…',
  field_currency: 'Currency',
  field_price: 'Price',
  field_compare_price: 'Compare price',
  field_compare_price_hint: 'Shown with strikethrough',
  field_cost_per_unit: 'Cost per unit',
  field_cost_per_unit_hint: 'Not shown to the customer',
  field_margin: 'Margin',
  field_profit: 'Profit',
  field_tax_toggle: 'Charge taxes on this product',
  field_sku: 'SKU',
  field_sku_hint: 'Unique — syncs with Shopify',
  field_barcode: 'Barcode (ISBN/UPC)',
  field_track_inventory: 'Track inventory',
  field_track_inventory_hint: '{{brand}} will notify when stock is low.',
  field_continue_selling: 'Continue selling without stock',
  field_continue_selling_hint: 'Useful for preorders or backorders.',
  field_stock: 'Available stock',
  field_low_stock_threshold: 'Low stock alert at',
  field_warehouse: 'Warehouse',
  field_is_physical: 'Physical product',
  field_is_physical_hint: 'Enable weight and dimensions for shipping.',
  field_weight: 'Weight',
  field_length: 'Length',
  field_width: 'Width',
  field_height: 'Height',
  field_has_variants: 'This product has variants',
  field_has_variants_hint:
    'If not, you sell a single version and the price + stock above will suffice.',
  field_option_name: 'Option name',
  field_add_value: 'Add value',
  field_add_option: 'Add another option',
  field_remove_option: 'Remove option',
  field_variant_name: 'Variant',
  field_variant_price: 'Price',
  field_variant_sku: 'SKU',
  field_variant_stock: 'Stock',
  field_show_more_variants: '+ {{count}} more variants · View all',
  field_seo_title: 'SEO title',
  field_seo_title_hint: '60 characters recommended',
  field_meta_description: 'Meta description',
  field_meta_description_hint: '155 characters recommended',
  field_agent_notes: 'Internal notes for the agent',
  field_agent_notes_hint: 'Only your team and agents can see this',
  field_seo_suggest_ai: 'Suggest with AI',
  sidebar_status: 'Status',
  sidebar_status_active: 'Active — visible to agents',
  sidebar_status_draft: 'Draft — only you',
  sidebar_status_archived: 'Archived',
  sidebar_channels: 'Available on',
  sidebar_visible_to_agents: 'Agents with access',
  sidebar_visible_to_agents_all_label: 'All agents',
  sidebar_visible_to_agents_hint:
    'Turn on "All agents" so every agent can recommend this product. Turn it off to pick specific agents.',
  sidebar_visible_to_agents_empty:
    'No ecommerce agents yet. Create one to assign visibility.',
  sidebar_checklist: 'Checklist',
  sidebar_checklist_subtitle: '{{done}} of {{total}} completed',
  sidebar_ai_title: '{{brand}} AI can help you',
  sidebar_ai_description:
    'Paste a URL, a photo or describe the product and we will generate name, description, tags and SEO in seconds.',
  sidebar_ai_button: 'Generate with AI',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram DM',
  channel_web: 'Web chat',
  channel_shopify: 'Shopify store',
  checklist_name: 'Name and description',
  checklist_image: 'At least 1 image',
  checklist_price: 'Price set',
  checklist_sku: 'SKU for inventory',
  checklist_category: 'Category assigned',
  action_discard: 'Discard',
  action_save_draft: 'Save draft',
  action_publish: 'Publish product',
  action_save: 'Save changes',
  toast_created: 'Product created successfully',
  toast_updated: 'Product updated successfully',
  toast_deleted: 'Product deleted successfully',
  toast_bulk_status: 'Status updated successfully',
  toast_bulk_category: 'Category assigned successfully',
  toast_bulk_channels: 'Channels updated successfully',
  toast_bulk_deleted: 'Products deleted successfully',
  toast_error: 'An error occurred. Please try again.',
  category_create_short: 'New',
  category_create_action: 'Create category',
  category_create_dialog_title: 'New category',
  category_create_name_label: 'Name',
  category_create_name_placeholder: 'e.g. Scented candles',
  category_create_dialog_confirm: 'Create',
  category_created: 'Category created',
  import_card_title: 'Import from URL',
  import_card_description:
    'Paste a product link and we’ll fill the form so you only review what matters. Today we support Shopify; more platforms soon.',
  import_card_placeholder: 'https://your-store.com/products/...',
  import_card_action: 'Import',
  import_card_footer:
    'Shopify only for now · this does not save the product — only fills the form.',
  import_success_title: 'Product imported',
  import_success_description:
    'Review the fields before publishing. Images, variants and pricing come from the source product.',
  import_success_toast: 'Imported. Review the product before saving.',
  import_undo: 'Undo import',
  import_category_hint:
    'Suggested category from source: "{{name}}". Pick one above or create a new one.',
  import_category_hint_dismiss: 'Got it',
  import_error_invalid_url: 'URL is not valid.',
  import_error_not_supported:
    'Only Shopify product URLs are supported right now.',
  import_error_fetch_failed:
    'Could not reach the store. Double-check the link or try again.',
  import_error_invalid_json:
    'That URL did not return a valid Shopify product. Make sure to paste the product URL.',
  import_error_unknown: 'Could not import the product. Try again.',
  empty_title: 'No products yet',
  empty_description:
    'Create your first product so your agents can recommend it.',
  delete_title: 'Delete product',
  delete_description:
    'Are you sure you want to delete this product? This action cannot be undone.',
  delete_confirm: 'Delete',
  delete_cancel: 'Cancel',
  image_dropzone_text: 'Drag images here or click to select',
  image_dropzone_specs: 'PNG, JPG, WEBP · max 5 MB · 1:1 recommended',
  image_primary: 'Primary',
  image_set_primary: 'Set as primary',
  image_delete: 'Delete',
  pagination_showing: 'Showing {{from}}–{{to}} of {{total}}',
  shopify_banner_title: 'Connect Shopify to sync your catalog',
  shopify_banner_description:
    'Once connected, products will be linked by SKU and stock will update in real time.',
  shopify_banner_button: 'Connect Shopify',
  shopify_banner_badge: 'Coming soon',
  table_updated: 'Updated',
  table_results: '{{count}} products',
  pagination_prev: 'Previous',
  pagination_next: 'Next',
  list_select_all: 'Select all',
  list_deselect_all: 'Deselect all',
  list_filter_label: 'Filter by status',
  list_sort_label: 'Sort products',
  preview_title: 'Preview',
  preview_subtitle: 'How it looks when Luna recommends it in chat.',
  preview_message: "Got just what you're looking for! Check out this option:",
  preview_view_detail: 'View detail',
  preview_default_name: 'Product name',
  preview_variants_available: '{{count}} variants available',
  footer_autosave: 'Changes saved automatically',
  footer_test_sandbox: 'Test in Sandbox',
  variants_table_count: 'Variant ({{count}})',
  variants_more_count: '+ {{count}} more variants',
  image_make_primary: 'Make primary',
  image_remove: 'Remove',
  image_count: '{{count}} / 15',
  bulk_change_status_to: 'Change to',
  bulk_set_active: 'Activate',
  bulk_set_draft: 'Mark as draft',
  bulk_set_archived: 'Archive',
  no_match_title: "We didn't find any products matching those filters",
  no_match_description:
    'Try adjusting the search, changing the category, or clearing the active filters.',
  no_match_clear: 'Clear filters',
  validation_required: 'This field is required',
  validation_min: 'Must be greater than or equal to {{min}}',
  validation_max: 'Maximum {{max}} characters',
  validation_must_be_number: 'Must be a valid number',
  validation_compare_gt_price: 'Compare price must be greater than the price',
  sections_title: 'Product sections',
  sections_subtitle:
    'Information blocks that Luna uses when recommending this product.',
  sections_templates_label: 'Templates',
  sections_template_benefits: 'Benefits',
  sections_template_features: 'Features',
  sections_template_usage: 'How to use',
  sections_template_specs: 'Specifications',
  sections_template_whats_included: "What's included",
  sections_template_target_audience: 'Who it’s for',
  sections_template_care: 'Care',
  sections_template_warranty: 'Warranty',
  sections_template_faq: 'FAQ',
  section_title_placeholder: 'Section title',
  section_content_placeholder:
    'Write the content Luna and your other agents will see…',
  section_add_custom: 'Add custom section',
  section_remove: 'Remove section',
  section_reorder: 'Reorder',
  sections_empty:
    'No sections yet. Start with a template or create a custom one.',
  sections_cap_reached:
    'You hit the {{max}} section limit. Remove one before adding more.',
  relations_title: 'Related products',
  relations_subtitle:
    'The agent uses these to suggest complements, bundles and alternatives.',
  relation_type_upsell: 'Upsell',
  relation_type_cross_sell: 'Cross-sell',
  relation_type_bundle: 'Bundle',
  relation_type_accessory: 'Accessory',
  relations_search_placeholder: 'Search the catalog…',
  relations_add_to: 'Add to {{type}}',
  relations_remove: 'Remove from list',
  relations_empty: 'No products in {{type}} yet.',
  relations_bundle_discount: 'Bundle discount (%)',
  relations_open_in_new_tab: 'Open in new tab',
};
